<template>
  <div id="user-binging">
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      title="关联用户"
      width="1000px"
      top="5vh"
      @close="closeModal"
    >
      <div class="user-binding-box">
        <div class="search-inp-box">
          <div class="qrcode_input" style="width: 300px">
            <el-input
              v-model="condition"
              placeholder="搜索用戶"
              @keyup.enter.native="conditionSearch"
            ></el-input>
          </div>

          <span class="search-btn-box" @click="conditionSearch"
            ><i class="el-icon-search icon-style"></i
          ></span>
        </div>
      </div>
      <div class="panel__body">
        <el-table
          ref="tableData"
          v-loading="loading"
          :data="tableData"
          height="calc(100vh - 350px)"
        >
          <el-table-column prop="" label="" width="55">
            <template slot-scope="scope">
              <img
                v-if="scope.row.UserHeadImgUrl == null"
                src="../../assets/images/icon/icon_header_avatar-default.svg"
                style="width: 30px; height: 30px"
                alt="头像"
              />
              <img
                v-else
                :src="scope.row.UserHeadImgUrl"
                style="width: 30px; height: 30px"
                alt="头像"
              />
            </template>
          </el-table-column>
          <el-table-column prop="UserName" label="姓名" width=""></el-table-column>
          <el-table-column prop="MobilePhone" label="手机" width=""></el-table-column>
          <el-table-column prop="UserEmail" label="邮箱" width=""></el-table-column>
          <el-table-column prop="" label="角色" width="">
            <template slot-scope="scope">
              <el-select
                v-if="scope.row.role == null"
                v-model="role"
                multiple
                collapse-tags
                placeholder="请选择"
              >
                <el-option
                  v-for="item in roleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex items-center justify-end" style="margin-top: 1em">
        <button class="qrcode_handle_btn">
          保存
        </button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
let _this = void 0

export default {
  name: 'UserBinding',
  components: {},
  filters: {},
  directives: {},
  mixins: [],
  props: {
    userBindProp: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      condition: '',
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 2,
      roleOptions: [
        { label: '编辑者', value: '编辑者' },
        { label: '管理者', value: '管理者' },
        { label: '查看者', value: '查看者' },
        { label: '项目管理员', value: '项目管理员' },
      ],
      role: null,
    }
  },
  computed: {
    // ...mapState('', {}),
  },
  watch: {
    userBindProp(val) {
      this.dialogVisible = val
    },
  },
  created() {
    _this = this
  },
  mounted() {
    this.refreshTable()
  },
  destroy() {},
  methods: {
    // ...mapMutations('', []),
    closeModal() {
      _this.$emit('close-user-binding-modal')
    },
    /*
     * 获取绑定人员列表数据
     * */
    async getUserBindListData() {
      this.loading = true
      const { success, data } = await this.$http({
        url: this.$api.getUnassignedInviteeUsers,
        params: {
          keyword: this.condition,
        },
      })
      if (success) {
        const { rows } = data
        this.tableData = rows
        this.loading = false
      } else {
        this.$message({
          type: 'error',
          message: '获取用户数据失败！',
        })
      }
    },
    /*
     * 刷新表格，用户初始化
     * */
    refreshTable() {
      this.getUserBindListData()
    },
    /*
     * 点击搜索按钮，添加查询
     * */
    conditionSearch() {
      this.refreshTable()
    },
  },
}
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.search-inp-box {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 1em;
}

.icon-style {
  font-size: 22px;
  color: #ffffff;
}
#user-binging .el-dialog__header {
  background: #f5f5f5 !important;
}
#user-binging .el-table__row {
  font-size: 12px !important;
  color: #000000 !important;
  height: 60px;
}
</style>
